module.exports = __webpack_public_path__ + "img/adult_content.70f18e21.svg";